/*
  Night / day and zoom toggles. Works on every page (inside the
  site and the locked page). There can be several copies of each toggle on
  a page; they all stay in sync. The starting values are set on <html> by
  snippets/zp-mode-init.liquid before the page paints.
*/
(() => {
  const root = document.documentElement;

  const save = (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  };

  // Night / day
  const modeToggles = document.querySelectorAll('[data-zp-mode-toggle]');
  const syncMode = () => {
    const day = root.getAttribute('data-mode') === 'day';
    modeToggles.forEach((toggle) => {
      toggle.setAttribute('aria-pressed', String(day));
      toggle.setAttribute('aria-label', day ? toggle.dataset.labelDay : toggle.dataset.labelNight);
    });
  };
  const setMode = (next) => {
    root.setAttribute('data-mode', next);
    save('zp-mode', next);
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta && window.zpModeColors) meta.setAttribute('content', window.zpModeColors[next]);
    syncMode();
  };
  modeToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const next = root.getAttribute('data-mode') === 'day' ? 'night' : 'day';
      // Cross-fade the page for the time set in Theme settings (the art is the same in both modes, so only the colors visibly fade).
      // Browsers without view transitions, or visitors who turned motion off, switch instantly.
      const fade = parseFloat(getComputedStyle(root).getPropertyValue('--mode-fade')) || 0;
      const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (fade > 0 && !calm && document.startViewTransition) {
        document.startViewTransition(() => setMode(next));
      } else {
        setMode(next);
      }
    });
  });
  syncMode();

  // Zoom on product grids: − = more, smaller products per row; + = fewer, bigger ones.
  // Steps run from 1 (biggest) down to -3 on desktop / -2 on phones (see snippets/zp-zoom-toggle.liquid).
  const zoomButtons = document.querySelectorAll('[data-zp-zoom-step]');
  const phone = window.matchMedia('(max-width: 749px)');
  const zoomLimits = () => ({ min: phone.matches ? -2 : -3, max: 1 });
  const currentZoom = () => parseInt(root.getAttribute('data-zoom'), 10) || 0;
  const syncZoom = () => {
    const { min, max } = zoomLimits();
    const zoom = currentZoom();
    zoomButtons.forEach((button) => {
      const step = Number(button.dataset.zpZoomStep);
      const atEnd = (step < 0 && zoom <= min) || (step > 0 && zoom >= max);
      button.setAttribute('aria-disabled', String(atEnd));
    });
  };
  zoomButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const { min, max } = zoomLimits();
      const next = Math.min(max, Math.max(min, currentZoom() + Number(button.dataset.zpZoomStep)));
      root.setAttribute('data-zoom', String(next));
      save('zp-zoom', String(next));
      syncZoom();
    });
  });
  phone.addEventListener('change', syncZoom);
  syncZoom();

  // Links that open the products at a set zoom (the header logo: 8 across on desktop). Phones keep their own zoom.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-zp-zoom-set]');
    if (!link || phone.matches) return;
    save('zp-zoom', link.dataset.zpZoomSet);
  });
})();
